import { defineMessages } from 'react-intl';

export const clinicianMaxPricingPlanCardMessages = defineMessages({
  cta: {
    defaultMessage: 'Get Clinician Max',
    id: 'ZDyPhKsCtO',
    description: 'Upgrade button on the Clinician Max pricing plan card',
  },
  keepCta: {
    defaultMessage: 'Keep Clinician Max',
    id: '8cnsikiUof',
    description:
      'Button on the Clinician Max pricing plan card when it is the current plan',
  },
});
